import { Locale } from '@bts-web/utils-lokalise';
import { css } from '@bts-web/utils-style-engine';
import { SavingsPlansTransactionsQuery } from '@bts-web/data-layer/server';
import {
  SavingsPlansListTranslationsKeys,
  SavingsPlansTransactionsTranslationsKeys,
} from '../types';
import { TransactionItem } from '../../transactions/TransactionItem/TransactionItem';
import { Link } from '../../common/components/Link/Link';
import { emptyTransactionsStyles } from '../utils/styles';

interface SavingsPlansLatestTransactionsContentProps {
  applicationLocale: Locale;
  className?: string;
  savingsPlanId?: string;
  latestTransactionsData: NonNullable<
    SavingsPlansTransactionsQuery['response']['savingsPlanTransactions']
  >;
  translations: SavingsPlansListTranslationsKeys &
    SavingsPlansTransactionsTranslationsKeys;
}

const SavingsPlansLatestTransactionsContent = ({
  latestTransactionsData,
  translations,
  applicationLocale,
  savingsPlanId,
}: SavingsPlansLatestTransactionsContentProps) => {
  const transactionNodes = latestTransactionsData?.edges?.map(
    (transactionItem) => transactionItem?.node,
  );

  const hasMoreData = latestTransactionsData.pageInfo?.hasNextPage;

  const redirectUrl = savingsPlanId
    ? `/savings-plans/transactions?savingsPlanId=${savingsPlanId}`
    : '/savings-plans/transactions';

  return transactionNodes?.length ? (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'small',
        padding: 'medium',
      })}
    >
      <div
        className={css({
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        })}
      >
        {translations.transactions}
        {hasMoreData && (
          <Link data-testid="see-all-link" size="small" href={redirectUrl}>
            <span
              className={css({
                gap: 'extra_small_2',
                px: 'medium',
                fontSize: 'small',
                display: 'flex',
                textDecoration: 'underline',
              })}
            >
              <p>{translations.seeAll}</p>
            </span>
          </Link>
        )}
      </div>

      <div>
        {transactionNodes?.filter(Boolean).map((transactionNode) => (
          <TransactionItem
            key={transactionNode?.id}
            transaction={transactionNode!}
            useSimpleTitle
            locale={applicationLocale}
            translations={translations}
          />
        ))}
      </div>
    </div>
  ) : (
    <span
      data-testid="empty-transactions"
      className={css({
        textAlign: 'left',
        fontFamily: 'inherit',
        fontSize: '16px',
        paddingX: 'medium',
      })}
    >
      <div>{translations.transactions}</div>
      <div className={emptyTransactionsStyles}>
        {translations.emptyStateNoTransactions}
      </div>
    </span>
  );
};

export { SavingsPlansLatestTransactionsContent };
